<template>
  <v-app id="inspire" dark v-if="this.$store.getters.user.details">
    
    <side-menu />

    <v-content>
      <v-container style="max-width:100%" v-if="this.items ">
        <selected-user @change="update" :items="this.items" />

        <calendar ref="mycal" />
      </v-container>
    </v-content>
    
  </v-app>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import sideMenu from "@/components/main/SideMenu.vue";
import calendar from "@/components/main/Calendar.vue";
import selectedUser from "@/components/main/SelectedUser.vue";
import axios from "axios";

export default {
  name: "Home",
  props: {
    source: String
  },
  components: {
    sideMenu,
    calendar,
    selectedUser
  },
  data: () => ({
    items: null
  }),
  computed: {},
  methods: {
    update() {
      // change the user with calendar data

      this.$refs.mycal.Update();
    },

    GetUsers() {
      let query = `query usersOfCompany($companyID: String!){
                        usersOfCompany(companyID : $companyID){
                            id
                            firstname,
                            lastname,
                            
                        }
                        }`;
      axios
        .post("/graphql", {
          query: query,
          variables: {
            companyID: this.$store.getters.user.details.companyId
          }
        })
        .then(result => {
          if (result.data.data.usersOfCompany) {
            this.items = result.data.data.usersOfCompany;

            this.items.forEach(user => {
              Object.assign(user, {
                fullname: `${user.firstname} ${user.lastname}`
              });
            });
            let selectedUser = 
             this.items.find(
              u => u.id == this.$store.getters.user.details.id
            );
            this.$store.commit("setSelectedUser", selectedUser);
          }
        })
        .catch(error => this.showError(error.message));
    }
  },
  created() {
    this.GetUsers();
  },
  mounted() {}
};
</script>
